import React, { useEffect } from "react";
import "../Modpages/Modal.css";

const Modal = ({ isOpen, onClose, children }) => {

  useEffect(() => {

    const esc = (e) => {
      if (e.key === "Escape") onClose();
    };

    if (isOpen) {
      document.body.style.overflow = "hidden";
      window.addEventListener("keydown", esc);
    }

    return () => {
      document.body.style.overflow = "auto";
      window.removeEventListener("keydown", esc);
    };

  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const stop = (e) => e.stopPropagation();

  return (
    <div className="founder-modal-overlay" onClick={onClose}>

      <div className="founder-modal-box" onClick={stop}>

        <button className="founder-modal-x" onClick={onClose}>
          ×
        </button>

        <div className="founder-modal-scroll">
          {children}
        </div>

        <div className="founder-modal-footer">
          <button onClick={onClose}>Close</button>
        </div>

      </div>

    </div>
  );
};

export default Modal;